import React from "react";

import { AreaChart, Area, ResponsiveContainer } from "recharts";

function r(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const data = [
  { name: "Page A", uv: r(100, 9000), pv: r(400, 7000), amt: r(700, 2000) },
  { name: "Page B", uv: r(100, 9000), pv: r(400, 7000), amt: r(700, 2000) },
  { name: "Page C", uv: r(100, 9000), pv: r(400, 7000), amt: r(700, 2000) },
  { name: "Page D", uv: r(100, 9000), pv: r(400, 7000), amt: r(700, 2000) },
  { name: "Page E", uv: r(100, 9000), pv: r(400, 7000), amt: r(700, 2000) },
  { name: "Page F", uv: r(100, 9000), pv: r(400, 7000), amt: r(700, 2000) },
  { name: "Page G", uv: r(100, 9000), pv: r(400, 7000), amt: r(700, 2000) },
];

const LoginChart = () => (
  <div className="login-chart">
    <ResponsiveContainer height={120} width="100%">
      <AreaChart
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        data={data}
        width={500}
        height={280}
        animationEasing="ease-in-out"
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="30%" stopColor="#FF3944" stopOpacity={1} />
            <stop offset="70%" stopColor="#FF3944" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="30%" stopColor="#FC6D52" stopOpacity={1} />
            <stop offset="70%" stopColor="#FC6D52" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorAmt" x1="0" y1="0" x2="0" y2="1">
            <stop offset="30%" stopColor="#F89481" stopOpacity={1} />
            <stop offset="70%" stopColor="#F89481" stopOpacity={0} />
          </linearGradient>
        </defs>

        <Area
          type="monotone"
          dataKey="uv"
          stroke="#FF3944"
          fillOpacity={1}
          fill="url(#colorUv)"
        />
        <Area
          type="monotone"
          dataKey="pv"
          stroke="#FC6D52"
          fillOpacity={1}
          fill="url(#colorPv)"
        />
        <Area
          type="monotone"
          dataKey="amt"
          stroke="#F89481"
          fillOpacity={1}
          fill="url(#colorAmt)"
        />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

export default LoginChart;
